import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, requirePaid = true }) {
  const { user, ready } = useAuth();
  if (!ready)
    return (
      <div data-testid="auth-loading" className="p-12 font-mono text-sm">
        Loading Bitbook...
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (requirePaid && !user.paid_entry) return <Navigate to="/pay-entry" replace />;
  return children;
}
